import api from "@/api";

export default {
    namespaced: true,

    actions: {

        async addLead(context, body) {
            let url = `/api/hubspot/leads/${body.placeGuid}`
            let formData = new FormData();
            formData.append('question_guid', body.question_guid);
            formData.append('type', body.type);
            formData.append('company_name', body.company_name);
            formData.append('site_id', body.site_id);
            formData.append('contact_info', body.contact_info);
            formData.append('rental_use', body.rental_use);
            formData.append('notes', body.notes);
            formData.append('submitted_by', body.submitted_by);
            formData.append('location[lat]', body.location.lat);
            formData.append('location[lng]', body.location.lng);
            formData.append('location[accuracy]', body.location.accuracy);
            formData.append('notes', body.notes);
            formData.append('audio', body.audio);
            for (var i = 0; body.images.length > i; i++) {
                formData.append('file[]', body.images[i]);
            }
            try {
                const response = await api.request("post", url, formData);
                return response.data
            } catch (error) {
                throw error;
            }
        },
    }
}
